import React from "react"
import {TableHeader} from "./TableHeader.js"
import {TableBody} from "./TableBody.js"

const NestedTable = ({
  columns,
  data,
  expandedRow,
  selected,
  handleBrandRowClick,
  handleCategoryRowClick,
}) => (
  <table>
    <TableHeader columns={columns} />
    <TableBody
      data={data}
      expandedRow={expandedRow}
      selected={selected}
      handleBrandRowClick={handleBrandRowClick}
      handleCategoryRowClick={handleCategoryRowClick}
    />
  </table>
)
export default NestedTable
